import * as actionTypes from "../actions/actionTypes";

const initialState = {
  user: {},
  isAuth: false,
  isLoading: true,
  isEditing: false,
  roles: [],
  errorMsg: "",
  success: false,
  showMissingDataPopup: false,
  notificationToken: null,
  notificationSettings: {
    alertasGenerales: true,
    alertasTransito: false,
    alertasSeguridad: false,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOGIN: {
      const { user } = action.payload;
      user.telefonoFijo = user.telefonoFijo ? user.telefonoFijo : null; // .replace(/[{(\-\s)}]/g, '')
      user.telefonoCelular = user.telefonoCelular ? user.telefonoCelular : null; // .replace(/[{(\-\s)}]/g, '')
      return {
        ...state,
        user,
        isAuth: true,
        isLoading: false,
      };
    }
    case actionTypes.LOGOUT: {
      return {
        ...state,
        user: {},
        isAuth: false,
      };
    }
    case actionTypes.INIT_UPDATE_USER_DATA: {
      return {
        ...state,
        errorMsg: "",
        success: false,
      };
    }
    case actionTypes.UPDATE_USER_DATA: {
      return {
        ...state,
        user: {
          ...state.user,
          ...action.updatedUserData,
        },
        errorMsg: "",
        success: true,
      };
    }
    case actionTypes.RESET_SUCCESS: {
      return {
        ...state,
        success: false,
      };
    }
    case actionTypes.UPDATE_USER_DATA_FAILED: {
      return {
        ...state,
        errorMsg: action.errorMsg,
        success: false,
      };
    }
    case actionTypes.SET_ROLES: {
      return {
        ...state,
        roles: action.roles,
      };
    }
    case actionTypes.SET_ROLES_FAILED: {
      return {
        ...state,
        errorMsg: action.errorMsg,
      };
    }
    case actionTypes.SET_MODO_ADULTO_MAYOR: {
      return {
        ...state,
        user: {
          ...state.user,
          modoMayor: action.payload,
        },
      };
    }
    case actionTypes.SHOW_MISSING_DATA_POPUP: {
      return {
        ...state,
        showMissingDataPopup: true,
      };
    }
    case actionTypes.HIDE_MISSING_DATA_POPUP: {
      return {
        ...state,
        showMissingDataPopup: false,
      };
    }
    case actionTypes.SET_NOTIFICATION_TOKEN: {
      return {
        ...state,
        notificationToken: action.payload,
      };
    }
    case actionTypes.INIT_UPDATE_NOTIFICATION_SETTINGS: {
      return {
        ...state,
        errorMsg: "",
        success: false,
      };
    }
    case actionTypes.UPDATE_NOTIFICATION_SETTINGS: {
      return {
        ...state,
        notificationSettings: {
          ...state.notificationSettings,
          ...action.payload,
        },
        errorMsg: "",
        success: true,
      };
    }
    case actionTypes.UPDATE_NOTIFICATION_SETTINGS_FAILED: {
      return {
        ...state,
        errorMsg: action.errorMsg,
        success: false,
      };
    }
    default:
      return state;
  }
};

export default reducer;
